import type { MapOptions } from "./map-interactive.type";

import { getGoogleMapsMapId } from "../map.helper";

export const MAP_DEFAULT_ZOOM = 15;

// Default map options for @vis.gl/react-google-maps
export const BASE_MAP_OPTIONS: MapOptions = {
  mapId: getGoogleMapsMapId(),
  mapTypeId: "roadmap",
  mapTypeControlOptions: {
    mapTypeIds: ["roadmap", "satellite"], // disable `hybrid` and `terrain`
  },
  minZoom: 2,
  maxZoom: 22,
  zoomControl: true,
  zoomControlOptions: {
    position: 7, // TOP_RIGHT
  },
  disableDefaultUI: true,
  mapTypeControl: true,
  fullscreenControl: true,
  streetViewControl: false,
  scrollwheel: true,
  rotateControl: false,
  scaleControl: false,
  keyboardShortcuts: true,
  clickableIcons: true,
  gestureHandling: "auto",
  disableDoubleClickZoom: true,
  draggableCursor: undefined,
  draggingCursor: undefined,
  tilt: 0,
  heading: 0,
  restriction: undefined,
  cameraControl: false,
  tiltInteractionEnabled: false,
  controlSize: 32,
};

/**
 * Montreal coordinates
 */
const MAP_DEFAULT_LAT = 45.508;
const MAP_DEFAULT_LNG = -73.587;
export const MAP_DEFAULT_CENTER_STRING = `${MAP_DEFAULT_LAT},${MAP_DEFAULT_LNG}`;
export const MAP_DEFAULT_CENTER = {
  lat: MAP_DEFAULT_LAT,
  lng: MAP_DEFAULT_LNG,
};
